// SimpleTradesHistory/constants.js

export const COLORS = {
  primary: '#00d4ff',
  success: '#10b981',
  danger: '#ef4444',
  warning: '#f59e0b',
  purple: '#8b5cf6',
  pink: '#ec4899',
  bg: {
    primary: '#0a0e13',
    secondary: '#111827',
    tertiary: '#1f2937',
    card: 'rgba(17, 24, 39, 0.8)',
  },
  text: {
    primary: '#ffffff',
    secondary: 'rgba(255, 255, 255, 0.7)',
    muted: 'rgba(255, 255, 255, 0.4)',
  },
  border: 'rgba(255, 255, 255, 0.08)',
};

// Format: "2025-07-07 09:28:00" -> "2025-07-07 09:28:00" (pass through)
export const formatDateTime = (dateStr) => {
  if (!dateStr) return '—';
  return dateStr;
};

// Format: "2025-07-07 09:28:00" -> "09:28:00"
export const formatTimeOnly = (dateStr) => {
  if (!dateStr) return '—';
  try {
    // Handle "YYYY-MM-DD HH:MM:SS" format
    const parts = dateStr.split(' ');
    return parts[1] || '—';
  } catch {
    return '—';
  }
};

export const formatPrice = (price) => {
  if (price === null || price === undefined) return '—';
  return Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatPnL = (value, showSign = true) => {
  if (value === null || value === undefined) return '—';
  const num = Number(value);
  const sign = showSign ? (num >= 0 ? '+' : '') : '';
  return `${sign}${Math.abs(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatPercent = (value, showSign = true) => {
  if (value === null || value === undefined) return '—';
  const num = Number(value);
  const sign = showSign ? (num >= 0 ? '+' : '') : '';
  return `${sign}${num.toFixed(4)}%`;
};

// Format: "2025-07-07 09:28:00" and "2025-07-07 09:33:00" -> duration
export const formatDuration = (entryTime, exitTime) => {
  if (!entryTime || !exitTime) return '—';
  try {
    // Parse "YYYY-MM-DD HH:MM:SS" format
    const entry = new Date(entryTime.replace(' ', 'T'));
    const exit = new Date(exitTime.replace(' ', 'T'));
    const diffMs = exit - entry;
    const diffMins = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    if (hours > 0) return `${hours}h ${mins}m`;
    return `${mins}m`;
  } catch {
    return '—';
  }
};

// Format: "2025-07-07 09:28:00" -> "7/7" for chart
export const formatShortDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    // Parse "YYYY-MM-DD HH:MM:SS" format
    const datePart = dateStr.split(' ')[0];
    const [year, month, day] = datePart.split('-');
    return `${parseInt(month)}/${parseInt(day)}`;
  } catch {
    return '';
  }
};

// The Date field is already "7-Jul" format from API
export const formatDateShort = (dateStr) => {
  if (!dateStr) return '—';
  return dateStr;
};
